export enum ShortBreakType {
  DriversWorkingHours = 0,
  LaborCode = 1,
}
